/**
 * Modul Sync-Fehler: ausgelöst, wenn z.B. das Modul noch nicht synchronisiert wurde
 */
export default class ModuleSyncError extends Error {
	constructor(message: string) {
		super(message);
		Object.setPrototypeOf(this, ModuleSyncError.prototype);
	}
}
